import type { ComponentProps } from "react"
import type { Media } from "#models/media"

import { ENVIRONMENT } from "#environment/env"
import { LazyVideo } from "#modules/optimization/media/lazyVideo"

type VideoBaseProps = { lazy?: boolean }
type NonMediaVideoProps = { media?: undefined; src: string } & VideoBaseProps & ComponentProps<"video">
type MediaVideoProps = { media: Media } & VideoBaseProps & Omit<ComponentProps<"video">, "src">

type VideoProps = NonMediaVideoProps | MediaVideoProps

/**
 * Video that is set up for automatic playback - loop, muted and disable all sharing or airplay options --> can be overwritten via props
 */
export function AutomaticVideo(props: VideoProps) {
  return <Video autoPlay loop muted playsInline preload={"none"} draggable={false} disablePictureInPicture disableRemotePlayback x-webkit-airplay="deny" {...props} />
}

/**
 * Video component that implements automatic loading behaviour based on CDN urls, nextjs public directory urls and dev mode
 * can be filled from media object or directly from explicit src url
 * can be lazy loaded
 */
export function Video(props: VideoProps) {
  if (props.lazy) {
    const { lazy, ...propsWithoutLazy } = props
    return <LazyVideo {...propsWithoutLazy} />
  }

  return <video {...props} src={getVideoSrc(props)} />
}

export function getVideoSrc(props: VideoProps) {
  let baseUrl = ENVIRONMENT.NEXT_PUBLIC_CDN_URL

  const rawSrc = props.media ? props.media.url : props.src

  // eslint-disable-next-line no-restricted-properties
  if (process.env.NODE_ENV === "development") {
    // TODO remove hardcode when using payload
    if (!rawSrc.startsWith("/uploads")) {
      baseUrl = "http://localhost:3000"
    } else baseUrl = "http://localhost:1337"
  }

  return `${baseUrl}${rawSrc}`
}
